"use client"

import { useEffect, useState } from "react"
import { ChatBubble } from "@medusajs/icons"
import { clx } from "@/lib/utils"
import { useTranslations } from "next-intl"

import { listConversations } from "@lib/data/conversations"
import ChatModal from "@modules/chat/components/chat-modal"

const POLL_INTERVAL_MS = 30_000

const HeaderChatButton = () => {
  const t = useTranslations("Nav")
  const [totalUnread, setTotalUnread] = useState(0)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const fetchUnread = async () => {
      const conversations = await listConversations()
      const count = conversations.reduce(
        (acc: number, conv: { unread_count?: number }) =>
          acc + (conv.unread_count ?? 0),
        0
      )
      setTotalUnread(count)
    }

    void fetchUnread()
    const id = setInterval(() => { void fetchUnread() }, POLL_INTERVAL_MS)
    return () => clearInterval(id)
  }, [])

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={
          totalUnread > 0
            ? t("messagesWithCount", { count: totalUnread })
            : t("messages")
        }
        className="relative flex h-9 w-9 items-center justify-center rounded-full transition-all hover:bg-ui-bg-subtle"
        data-testid="header-chat-button"
      >
        <ChatBubble width={20} height={20} />
        {totalUnread > 0 && (
          <span
            className={clx(
              "absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full",
              "bg-ui-fg-interactive px-1 txt-xsmall text-white"
            )}
            data-testid="header-chat-badge"
          >
            {totalUnread > 99 ? "99+" : totalUnread}
          </span>
        )}
      </button>
      <ChatModal open={open} onOpenChange={setOpen} />
    </>
  )
}

export default HeaderChatButton
